export default "__VITE_ASSET__ClJ9aeng__"